module.exports = __webpack_public_path__ + "images/newerp_button3.1792157180594.png";